import React, { createContext, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./component/Home/Home/Home";
import NotFound from "./component/NotFound/NotFound";
import Project from "./component/Projects/Project/Project";
import Blog from "./component/Blogs/Blog/Blog";
import About from "./component/About/About";
import Contact from "./component/Contact/Contact";

export const myContext = createContext();

function App() {
  const [whiteColor, setWhiteColor] = useState(false);
  return (
    <main
      className={whiteColor ? ` App lightColor` : "App text-white darkColor"}
    >
      <myContext.Provider value={[whiteColor, setWhiteColor]}>
        <Router>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/portfolio">
              <Home />
            </Route>

            <Route path="/project">
              <Project />
            </Route>
            <Route path="/blog">
              <Blog />
            </Route>

            <Route path="/about">
              <About />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>

            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Router>
      </myContext.Provider>
    </main>
  );
}

export default App;
